<template>
  <div class="signin-container">
    <div class="signin-element">
      <div
        style="margin-top: 60px"
        v-if="!storeData.root_name"
        v-loading="true"
      />
      <div v-else>
        <div class="store-name">
          <span>{{ storeData.display_name }}</span>
        </div>
        <a
          :href="`https://maps.google.com/?q=${storeData.display_location_name},${storeData.display_location_state}`"
          target="_blank"
          class="row-info mt15"
        >
          <div class="icon-info-wrapper">
            <img src="@/assets/ic_home_location.png" class="icon-info" />
          </div>
          <span style="line-height: 25px; font-size: 14px"
            >{{ storeData.display_location_name }},
            <br />
            <span>{{ storeData.display_location_state }}</span>
          </span>
        </a>
        <a :href="`tel:${storeData.phone_number}`" class="row-info mt12">
          <div class="icon-info-wrapper">
            <img src="@/assets/ic_home_phone.png" class="icon-info" />
          </div>
          <span style="font-size: 14px">{{ storeData.phone_number }}</span>
        </a>
      </div>

      <div class="body-container information">
        <div class="source-view normal-button" @click="source = 'Appointment'">
          <span class="source-text">Appointment</span>
          <img
            v-if="source == 'Appointment'"
            src="@/assets/ic_check_active.png"
            style="width: 25px; height: 25px"
          />
          <img
            v-else
            src="@/assets/ic_check_inactive.png"
            style="width: 25px; height: 25px"
          />
        </div>
        <div class="source-view normal-button" @click="source = 'Walking'">
          <span class="source-text">Walk-in</span>
          <img
            v-if="source == 'Walking'"
            src="@/assets/ic_check_active.png"
            style="width: 25px; height: 25px"
          />
          <img
            v-else
            src="@/assets/ic_check_inactive.png"
            style="width: 25px; height: 25px"
          />
        </div>
        <span class="title mb20 mt30">Customer</span>
        <PhoneInput
          @input="phoneInput"
          :error="phoneNumber.error"
          placeholder="Your Phone Number"
        />
        <div class="text-field" v-loading="gettingName">
          <input v-model="fullName" class="input" placeholder="Name" />
        </div>
      </div>
      <div class="body-container service">
        <span class="title mb20">Service</span>
        <div class="list-service">
          <service-item
            v-for="(item, index) in services"
            :index="index"
            :key="item.service_id"
            :title="item.type"
            :isSelected="
              selectedServices.find((s) => s.service_id == item.service_id) !=
              null
            "
            v-on:onItemClick="() => onSelectedItem(index)"
          />
        </div>
      </div>
      <div class="body-container technician">
        <span class="title mb20">Request Technician</span>
        <div
          class="btn-technician-container normal-button"
          @click="dialogTechnician = true"
        >
          <span v-if="tech.full_name" class="tech">{{ tech.full_name }}</span>
          <span v-else class="tech-placeholder">Select technician</span>
          <img
            src="@/assets/ic_triangle.png"
            style="height: 15px; widht: auto"
          />
        </div>
      </div>
      <!-- <div class="body-container agreement">
        <img
          v-if="checked"
          src="@/assets/radioactive.png"
          class="icon-check"
          @click="checked = false"
        />
        <img
          v-else
          src="@/assets/radioinactive.png"
          class="icon-check"
          @click="checked = true"
        />
        <a
          target="_blank"
          href="https://storage.googleapis.com/usavina/salonaz/store/agreement/aveaston.pdf"
          class="agree-text"
        >
          Please read and Agree to the
          <u> <b>Hold Harmless Agreement</b> COVID-19 </u>
        </a>
      </div> -->
    </div>
    <div class="cta-bottom">
      <gradient-button title="Sign In" @onClick="onSignIn" />
    </div>
    <el-dialog title="Notes" :visible.sync="dialogNote" :width="dialogWidth">
      <el-input
        v-model="note"
        autocomplete="off"
        placeholder="Enter your notes"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogNote = false">Cancel</el-button>
        <el-button style="margin-left: 10px" type="primary" @click="onConfirm"
          >Confirm</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogTechnician"
      :width="dialogWidth"
      center="true"
      @close="() => (dialogTechnician = false)"
    >
      <span class="tech-title" slot="title">Technicians</span>
      <div class="list-technician">
        <div
          v-for="(item, index) in technician"
          :key="item.user_id"
          class="btn-tech normal-button"
          v-bind:class="{
            left: index % 3 == 0,
            right: index % 3 == 2,
            center: index % 3 == 1,
          }"
          @click="() => onSelectTech(item)"
        >
          <span class="tech">{{ item.full_name }}</span>
        </div>
      </div>
      <div class="techniciant-field">
        <el-input
          v-model="technician_notes"
          placeholder="Enter technician name"
        />
        <el-button
          style="margin-left: 10px"
          v-if="technician_notes != ''"
          type="primary"
          @click="applyTechniciantNotes"
          >Confirm</el-button
        >
      </div>
    </el-dialog>
    <purchase-success-alert
      v-if="isComplete && !isGroup"
      @onDismiss="onDismiss"
    />
    <purchase-group-success
      v-if="isComplete && isGroup"
      @onDismiss="onDismiss"
      :urlGroup="urlGroup"
      @onCopyClick="onCopyClick"
    />
  </div>
</template>

<script>
import GradientButton from "@/components/GradientButton";
import PurchaseSuccessAlert from "@/components/PurchaseSuccessAlert";
import PurchaseGroupSuccess from "@/components/PurchaseGroupSuccess";
import {
  getServices,
  getTechnician,
  createTicket,
  getDisplayName,
  findCustomer,
  findOrderId,
  getStoreSettings,
} from "@/api/home";
import ServiceItem from "./components/ServiceItem";
import { Message, Loading } from "element-ui";
import PhoneInput from "@/components/PhoneInput";
import SocketUtils from "@/utils/SocketUtils";
import moment from "moment";

export default {
  name: "SignIn",
  components: {
    GradientButton,
    ServiceItem,
    PurchaseSuccessAlert,
    PurchaseGroupSuccess,
    PhoneInput,
  },
  data() {
    return {
      source: "Appointment",
      note: "",
      tech: {},
      fullName: "",
      phoneNumber: {
        obj: {
          number: {
            input: "",
          },
        },
        error: "",
      },
      services: [],
      technician: [],
      selectedServices: [],
      dialogNote: false,
      dialogTechnician: false,
      checked: true,
      displayName: "",
      isComplete: false,
      isGroup: false,
      storeName: null,
      groupId: null,
      groupName: null,
      storeData: {},
      technician_notes: "",
      gettingName: false,
      timezone: "-05:00",
    };
  },
  computed: {
    device() {
      return this.$store.state.app.device;
    },
    dialogWidth() {
      if (this.device == "mobile") return "100%";
      return "600px";
    },
    urlGroup() {
      return `${window.location.host}/signin?storename=${this.storeName}&group_id=${this.groupId}&group_name=${this.groupName}`;
    },
    phoneInput() {
      const self = this;
      return (val, obj) => {
        if (obj.valid) {
          self.autoFullName(obj?.nationalNumber);
        }
        if (obj.valid) {
          self.phoneNumber.error = "";
        }
        self.phoneNumber.obj = obj;
      };
    },
  },
  methods: {
    async findCurrentOrder() {
      const startDate = moment(new Date())
        .utcOffset(this.timezone, true)
        .startOf("day")
        .format();
      const endDate = moment(new Date())
        .utcOffset(this.timezone, true)
        .endOf("day")
        .format();
      const orderIdRes = await findOrderId({
        store: this.storeName,
        from: startDate,
        to: endDate,
      });
      if (orderIdRes.length == 0) return 0;
      return orderIdRes[0].order_number;
    },
    autoFullName(phone) {
      if (!phone) return;
      const self = this;
      this.gettingName = true;
      findCustomer(phone, this.storeName)
        .then((res) => {
          self.fullName = res.full_name;
          self.email = res.email || "";
          this.gettingName = false;
        })
        .catch(() => {
          self.fullName = "";
          self.email = "";
          this.gettingName = false;
        });
    },
    applyTechniciantNotes() {
      this.tech = {
        ...this.technician[0],
        full_name: this.technician_notes,
      };
      this.dialogTechnician = false;
    },
    onCopyClick() {
      Message({
        message: "Copied",
        type: "success",
        duration: 2 * 1000,
      });
    },
    onDismiss() {
      this.isComplete = false;
      if (this.isGroup) {
        setTimeout(() => {
          location.reload();
        }, 1000);
      } else {
        location.reload();
      }
    },
    onSelectTech(tech) {
      this.tech = tech;
      this.dialogTechnician = false;
    },
    onConfirm() {
      this.dialogNote = false;
      const other = this.services.find((s) => s.type == "Other");
      const indexSelected = this.selectedServices.indexOf(other);
      if (this.note != "") {
        if (indexSelected > -1) return;
        this.selectedServices.push(other);
      } else {
        if (indexSelected > -1) {
          this.selectedServices.splice(indexSelected, 1);
        }
        return;
      }
    },
    async onSignIn() {
      let error = "";
      if (!this.storeName) {
        error = "Invalid Store Name";
      } else if (this.selectedServices.length == 0) {
        error = "Please choose service";
      } else if (this.phoneNumber.obj.number.input == "") {
        error = "Please fill your phone number";
      } else if (this.fullName == "") {
        error = "Please fill your name";
      } else if (!this.phoneNumber.obj.valid) {
        error = "Invalid phone number";
      }
      if (error != "") {
        Message({
          message: error,
          type: "error",
          duration: 5 * 1000,
        });
        return;
      }
      const currentOrder = await this.findCurrentOrder();
      const country_code = this.phoneNumber.obj.country.dialCode;
      const phone_number = this.phoneNumber.obj.nationalNumber;
      const loadingInstance = Loading.service({ fullscreen: true });
      const body = {
        order_number: currentOrder + 1,
        requested_id: this.tech.user_id || 0,
        phone_number: phone_number,
        country_code: "+" + country_code,
        full_name: this.fullName,
        customer_source: this.source,
        service_ids: this.selectedServices.map((s) => s.service_id),
        assignee_id: this.technician[0].user_id,
        other_notes: this.note,
        store: this.storeName,
        agreement_checked: this.checked,
        notes: "",
        technician_notes: this.technician_notes,
      };
      if (this.isGroup) {
        this.groupId = Math.round(new Date().getTime() / 1000);
        this.groupName = this.fullName;
        body.group_id = this.groupId;
        body.group_name = this.groupName;
      }
      if (this.groupId) {
        body.group_id = this.groupId;
        body.group_name = this.groupName;
      }
      createTicket(body)
        .then((res) => {
          console.log(res);
          loadingInstance.close();
          SocketUtils.socket.emit("SUBMIT", this.storeName);
          this.isComplete = true;
          this.checked = false;
        })
        .catch((e) => {
          loadingInstance.close();
          console.log(e.message);
        });
    },
    onSelectedItem(index) {
      const item = this.services[index];
      if (item.type == "Other") {
        this.dialogNote = true;
        return;
      }
      const isSelected =
        this.selectedServices.find((s) => s.service_id == item.service_id) !=
        null;
      if (isSelected) {
        const indexSelected = this.selectedServices.indexOf(item);
        if (indexSelected > -1) {
          this.selectedServices.splice(indexSelected, 1);
        }
      } else {
        this.selectedServices.push(item);
      }
    },
  },
  created() {
    this.storeName = this.$route.query.storename;
    getStoreSettings(this.storeName).then((res) => {
      if (res.timezone) this.timezone = res.timezone;
    });
    this.isGroup = this.$route.query.group;
    this.groupId = this.$route.query.group_id;
    this.groupName = this.$route.query.group_name;
    if (!this.storeName) {
      Message({
        message: "Invalid Store Name",
        type: "error",
        duration: 5 * 1000,
      });
      return;
    }
    Promise.all([
      getServices(),
      getTechnician(this.storeName),
      getDisplayName(this.storeName),
    ])
      .then((res) => {
        this.services = res[0];
        this.technician = res[1];
        this.storeData = res[2];
        this.tech = this.technician[0];
      })
      .catch((e) => console.log(e));
  },
};
</script>

<style>
.el-dialog--center .el-dialog__body {
  padding: 20px !important;
}
</style>

<style lang="scss" scoped>
.tech {
  color: #222222;
  font-weight: 600;
}
.text-field {
  margin-bottom: 20px;
}
.input {
  width: 100%;
  border-radius: 5px;
  border: 1px solid #eeeeee;
  background-color: #f9f7f1;
  height: 50px;
  font-size: 16px;
  font-weight: 600;
  outline: none;
  outline-style: none;
  padding: 0 20px;
  box-shadow: none;
}
.signin-container {
  display: flex;
  flex-direction: column;
  color: #222222;
  padding-left: 70px;
  padding-right: 70px;
  .signin-element {
    border-radius: 5px;
    margin: 20px 20px 120px 20px;
    background-color: #fff9ec;
    box-shadow: 0 5px 10px rgba($color: #000000, $alpha: 0.1);
    padding: 20px 0;
  }
  .tech-title {
    font-weight: bold;
    font-size: 18px;
  }
  .el-dialog__wrapper {
    .el-dialog--center {
      .el-dialog__body {
        padding: 20px !important;
      }
    }
  }
  .icon-info-wrapper {
    height: 20px;
    width: 20px;
    margin-right: 15px;
    display: flex;
    justify-content: center;
  }
  .icon-info {
    height: 16px;
    width: auto;
  }
  .row-info {
    display: flex;
    align-items: center;
    margin-left: 20px;
    margin-right: 20px;
  }
  .store-name {
    font-weight: bold;
    font-size: 20px;
    margin: 10px 20px 0 20px;
    display: flex;
    justify-content: center;
  }
  .underline {
    text-decoration: underline;
  }
  .body-container {
    display: flex;
    flex-direction: column;
  }
  .information {
    margin: 20px 20px 0 20px;
    .source-view {
      width: 200px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 25px;
      .source-text {
        font-weight: bold;
        font-size: 18px;
      }
    }
  }
  .service {
    margin: 10px 20px 0 20px;
    .list-service {
      display: flex;
      flex-wrap: wrap;
    }
  }
  .technician {
    margin: 15px 20px 0 20px;
    .btn-technician-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 15px;
      height: 50px;
      border: 1px solid #eeeeee;
      border-radius: 5px;
      background-color: #f9f7f1;
      .tech-placeholder {
        font-weight: 600;
        color: #9b9b9b;
      }
      .tech {
        font-weight: 600;
      }
    }
  }
  .techniciant-field {
    display: flex;
  }
  .list-technician {
    display: flex;
    flex-wrap: wrap;
  }
  .btn-tech {
    padding: 15px 10px;
    border: 1.5px solid #eeeeee;
    border-radius: 6px;
    width: calc(33% - 5px);
    margin-bottom: 10px;
  }
  .left {
    margin-right: 5px;
  }
  .right {
    margin-left: 5px;
  }
  .center {
    margin-left: 5px;
    margin-right: 5px;
  }
  .tech {
    font-weight: 600;
    font-size: 16px;
  }
  .title {
    font-weight: bold;
    font-size: 18px;
  }
  .agreement {
    flex-direction: row;
    margin: 30px 20px 0 20px;
    .agree-text {
      font-size: 18px;
      line-height: 25px;
    }
    .icon-check {
      width: auto;
      height: 20px;
      margin-right: 20px;
    }
  }
  .cta-bottom {
    position: fixed;
    height: 100px;
    left: calc(50% - 300px);
    right: calc(50% - 300px);
    bottom: 0px;
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    background-color: white;
  }
}
@media only screen and (max-width: 600px) {
  .signin-container {
    padding-left: 0;
    padding-right: 0;
    .cta-bottom {
      left: 20px;
      right: 20px;
      padding-left: 0px;
      padding-right: 0px;
    }
    .tech {
      font-size: 14px;
      font-weight: 600;
    }
    .btn-tech {
      width: calc(33% - 6px);
    }
  }
}
</style>